module.exports = __webpack_public_path__ + "static/media/footer.404e6820.png";